export default {
  mock: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'http://localhost:3033',
    productionV1ApiBaseUrl: 'http://localhost:3033',
    salesOrderV1ApiBaseUrl: 'http://localhost:3033',
    prodDataV1ApiBaseUrl: 'http://localhost:3033',
    userV2ApiBaseUrl: 'http://localhost:3033',
    itemV1ApiBaseUrl: 'http://localhost:3033',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 0,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 5000,
  },
  local: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 0,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 5000,
  },
  test: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 0,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 5000,
  },
  dev: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://dev-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 500,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 60000,
  },
  uat: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://uat-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://uat-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://uat-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://uat-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://uat-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 500,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 60000,
  },
  sit: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://sit-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://sit-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://sit-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://sit-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://sit-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 0,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 60000,
  },
  pre: {
    clientId:
      '171849099600-icgaf54gmubuacpbtr9ivj0mnmifc99d.apps.googleusercontent.com',
    hostedDomain: 'int.test.morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://pre-api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://pre-api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://pre-api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://pre-api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://cit-api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://pre-api.morrisons.com/manufacturing-item/v1',
    apiKey: 'mkaPiwhhf4vH9Ga9rmDSPVPa75uKN7hv',
    uiDelay: 500,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 60000,
  },
  prod: {
    clientId:
      '316045974946-tui7n0eh6d0jq2f866c36qdvo1k25on9.apps.googleusercontent.com',
    hostedDomain: 'morrisonsplc.co.uk',
    manufacturingV1ApiBaseUrl: 'https://api.morrisons.com/manufacturing-sales-order-dispatcher/v1',
    productionV1ApiBaseUrl: 'https://api.morrisons.com/manufacturing-sales-order-app/v1',
    salesOrderV1ApiBaseUrl: 'https://api.morrisons.com/manufacturing-sales-order/v1',
    prodDataV1ApiBaseUrl: 'https://api.morrisons.com/manufacturing-production-data/v1',
    userV2ApiBaseUrl: 'https://api.morrisons.com/user/v2',
    itemV1ApiBaseUrl: 'https://api.morrisons.com/manufacturing-item/v1',
    apiKey: 'Gh7kJzj7BKAuneNOOXN19fbXwhkQfWSe',
    uiDelay: 0,
    logoutTimer: 1800000,
    eventLogRefreshRate: 60000,
    appStatusInterval: 60000,
  },
}[process.env.REACT_APP_ENV];
